<template>
  <div class="order-detail">
    <Header title="订单详情"></Header>
    <div class="content">
      <!-- 套餐内容 -->
      <div class="combo">
        <van-cell-group>
          <van-cell
            :title="item.itemName"
            :value="item.quantity + item.unit"
            v-for="(item, index) in orderDetail.serviceItems"
            :key="index"
          />
        </van-cell-group>
        <div class="rules">
          <div class="title">活动规则</div>
          <div class="rules-content">
            {{ orderDetail.promotionRule }}
          </div>
        </div>
      </div>
      <!-- 订单信息 -->
      <div class="order-info">
        <div>订单编号：{{ orderDetail.orderNo }}</div>
        <div>订单时间：{{ orderDetail.payTime }}</div>
        <div>支付方式：微信支付</div>
        <div>支付状态：{{ orderDetail.payStatus | payStatus }}</div>
        <div>车主手机：{{ orderDetail.phone }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import { orderInfo } from "@/api/order";
export default {
  components: {
    Header
  },
  data() {
    return {
      orderDetail: {}
    };
  },
  filters: {
    payStatus: function(value) {
      switch (value) {
        case 0:
          value = "待支付";
          break;
        case 1:
          value = "已支付";
          break;
        case 2:
          value = "已过期";
          break;
        default:
          break;
      }
      return value;
    }
  },
  mounted() {
    this.handleOrderDetail(this.$route.query.orderNo);
  },
  methods: {
    // 订单详情
    handleOrderDetail(orderNo) {
      orderInfo(orderNo).then(res => {
        // console.log("订单详情:", res);
        this.orderDetail = res;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.order-detail {
  .content {
    padding: 10px 15px;

    .combo {
      margin-bottom: 20px;
      background-color: #f6f7f9;
      border-radius: 10px;

      .rules {
        padding: 20px 10px;

        .title {
          margin-bottom: 10px;
          text-align: left;
        }

        .rules-content {
          white-space: pre-line;
          text-align: left;
          font-size: 14px;
          color: #7e7e7e;
        }
      }
    }

    .order-info {
      padding: 10px;
      background-color: #f6f7f9;
      border-radius: 10px;
      text-align: left;
      color: #7e7e7e;

      div {
        margin-bottom: 10px;
      }

      div:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
<style lang="scss">
.order-detail {
  .content {
    .combo {
      .van-cell {
        padding: 10px 10px;
        background-color: #f6f7f9;
        font-size: 16px;

        .van-cell__title {
          text-align: left;
        }
      }
    }
  }
}
</style>
